// routes
import { PATH_DASHBOARD } from "../../../routes/paths";
// components

// ----------------------------------------------------------------------

// const icon = (name) => (
//   <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
// );

const icon = (name) => (
  <img alt={name} src={`/assets/icons/navbar/${name}.svg`} />
);

const ICONS = {
  user: icon("ic_user"),
  ecommerce: icon("ic_ecommerce"),
  analytics: icon("ic_analytics"),
  dashboard: icon("ic_dashboard"),
  coupon: icon("ic_coupon"),
  notification: icon("ic_notification"),
  profile: icon("ic_profile"),
  pages: icon("ic_pages"),
  blogs: icon("ic_blogs"),
  settings: icon("ic_settings"),
  tripHour: icon("ic_trip_hr"),
  vehicle: icon("ic_vehicle"),
  reports: icon("ic_reports"),
  contacts: icon("ic_contacts"),
  testimonials: icon("ic_testimonials"),
  school: icon("ic_school"),
  dress: icon("ic_dress"),
  size: icon("ic_size"),
  category: icon("ic_category"),
  house: icon("ic_house"),
  product: icon("ic_product"),
  orders: icon("ic_order"),
};

const navConfig = [
  // TODO: order management
  {
    subheader: "Order Management",
    items: [
      {
        title: "Orders List",
        path: PATH_DASHBOARD.orders.list,
        icon: ICONS.orders,
      },
    ],
  },

  // TODO: products
  {
    subheader: "Products",
    items: [
      {
        title: "Products",
        path: PATH_DASHBOARD.products.root,
        icon: ICONS.product,
        children: [
          {
            title: "Products list",
            path: PATH_DASHBOARD.products.list,
          },
          {
            title: "Add Product",
            path: PATH_DASHBOARD.products.add,
          },
        ],
      },
    ],
  },

  // TODO: entriessss
  {
    subheader: "Carnation Entries",
    items: [
      {
        title: "Carnation Entries",
        path: PATH_DASHBOARD.entries.root,
        icon: ICONS.school,
        children: [
          {
            title: "Schools",
            path: PATH_DASHBOARD.entries.schools.root,
            // icon: ICONS.school,
            children: [
              {
                title: "School list",
                path: PATH_DASHBOARD.entries.schools.list,
              },
              { title: "Add School", path: PATH_DASHBOARD.entries.schools.add },
            ],
          },

          {
            title: "Categories",
            path: PATH_DASHBOARD.entries.categories.root,
            // icon: ICONS.category,
            children: [
              {
                title: "Categories list",
                path: PATH_DASHBOARD.entries.categories.list,
              },
              {
                title: "Add Category",
                path: PATH_DASHBOARD.entries.categories.add,
              },
            ],
          },

          {
            title: "Sizes",
            path: PATH_DASHBOARD.entries.sizes.root,
            // icon: ICONS.size,
            children: [
              {
                title: "Sizes list",
                path: PATH_DASHBOARD.entries.sizes.list,
              },
              {
                title: "Add Size",
                path: PATH_DASHBOARD.entries.sizes.add,
              },
            ],
          },

          {
            title: "Houses",
            path: PATH_DASHBOARD.entries.houses.root,
            // icon: ICONS.house,
            children: [
              {
                title: "Houses list",
                path: PATH_DASHBOARD.entries.houses.list,
              },
              {
                title: "Add House",
                path: PATH_DASHBOARD.entries.houses.add,
              },
            ],
          },

           {
            title: "Types",
            path: PATH_DASHBOARD.entries.types.root,
            // icon: ICONS.house,
            children: [
              {
                title: "Types list",
                path: PATH_DASHBOARD.entries.types.list,
              },
              {
                title: "Add Type",
                path: PATH_DASHBOARD.entries.types.add,
              },
            ],
          },
        ],
      },
    ],
  },

  // analytics
  // ----------------------------------------------------------------------
  {
    subheader: "general",
    items: [
      {
        title: "Dashboard",
        path: PATH_DASHBOARD.dashboard,
        icon: ICONS.dashboard,
      },
      { title: "Profile", path: PATH_DASHBOARD.profile, icon: ICONS.profile },
      // { title: 'Notifications', path: PATH_DASHBOARD.notification, icon: ICONS.notification },
    ],
  },

  // // TODO: users
  // {
  //   subheader: "User and Team",
  //   items: [
  //     {
  //       title: "Registered Users",
  //       path: PATH_DASHBOARD.users.root,
  //       icon: ICONS.user,
  //       children: [
  //         {
  //           title: "Registered users list",
  //           path: PATH_DASHBOARD.users.list,
  //         },
  //       ],
  //     },
  //   ],
  // },

  // {
  //   subheader: "Contact",
  //   items: [
  //     {
  //       title: "Contacts",
  //       path: PATH_DASHBOARD.contacts.root,
  //       icon: ICONS.contacts,
  //       children: [
  //         {
  //           title: "Contacts list",
  //           path: PATH_DASHBOARD.contacts.list,
  //         },
  //         {
  //           title: "Add Contact",
  //           path: PATH_DASHBOARD.contacts.add,
  //         },
  //       ],
  //     },
  //   ],
  // },

  // MANAGEMENT
  // ----------------------------------------------------------------------
  {
    subheader: "management",
    items: [
      {
        title: "Help and Support",
        path: PATH_DASHBOARD.manage.root,
        icon: ICONS.user,
        children: [{ title: "FAQs", path: PATH_DASHBOARD.manage.faqs }],
      },
      {
        title: "Registered Users",
        path: PATH_DASHBOARD.users.list,
        icon: ICONS.user,
      },
      {
        title: "Contacts",
        path: PATH_DASHBOARD.contacts.root,
        icon: ICONS.contacts,
        children: [
          {
            title: "Contacts list",
            path: PATH_DASHBOARD.contacts.list,
          },
          {
            title: "Add Contact",
            path: PATH_DASHBOARD.contacts.add,
          },
        ],
      },
    ],
  },
];

export default navConfig;
